import React, { useContext } from "react";
import { FormContext } from "./Form";
import { Informative } from "../../Inputs/General/Index";
import { CreationArea } from "./Styles";

export default function CreationDate({ value, className = "" }) {
  /**
   * @type {{
   *    document:import("types/typedef/documents").DocumentI
   * }}
   */
  const { document } = useContext(FormContext);

  return (
    <>
      {className !== "" ? (
        <div>
          <Informative
            readonly={true}
            label="Creación"
            value={!value ? document.createdDate.parsed : value}
          />
        </div>
      ) : (
        <CreationArea>
          <Informative
            readonly={true}
            label="Creación"
            value={!value ? document.createdDate.parsed : value}
          />
        </CreationArea>
      )}
    </>
  );
}
